import React, { useContext } from "react";
// import BannerDesktop from "images/kosmofi/kosmofi-banner-desktop.png";
import ImageBuildYourCreditScore from "images/kosmofi/kosmofi-build_your_credit_score.png";
import ImageCustomizableSpendingPower from "images/kosmofi/kosmofi-customizable_spending_power.png";
import ImageNoCreditHistory from "images/kosmofi/kosmofi-no_credit_history.png";
import { BreakpointContext } from "components/common";
import BoostHeader from "components/BoostHeader";
import boostWave from "images/boost/boost-wave.webp";
import BoostFooter from "components/BoostFooter";
import { Helmet } from "react-helmet";
import LandingForm from "./LandingForm";
import {
  HeaderTextMobile,
  BUSINESS_FUNDING,
  NO_CREDIT_NEEDED,
} from "./HeaderText";
import CheckMarkTexts from "./CheckMarkText";
import ActionCard from "./ActionCard";
import PageBreak from "./PageBreak";
import SocialProofImages from "./SocialProofImages";
import TestimonialCards from "./TestimonialCards";
import BoostVideo from "./BoostVideo";
import { BureauLogo } from "./BureauLogo";

const KosmofiLanding = () => {
  const { isBelow } = useContext(BreakpointContext);
  const belowMd = isBelow("md");

  return (
    <div className="flex flex-col min-h-screen h-full lg:overflow-hidden lg:pb-0">
      <Helmet>
        <title>Tomo: The VIP Business Card to Boost Your Credit Fast</title>
      </Helmet>
      <div className="bg-black w-full">
        <BoostHeader />
      </div>
      <div className="relative w-full flex flex-col pt-4 md:pt-16 lg:pt-0 lg:flex-row-reverse h-full justify-center md:items-start md:justify-start bg-black lg:min-h-[601px] overflow-hidden">
        <div className="max-w-page bg-transparent">
          {belowMd && (
            <>
              <div className="w-full grid place-items-center m-2">
                <HeaderTextMobile text={BUSINESS_FUNDING} />
                <HeaderTextMobile text={NO_CREDIT_NEEDED} />
              </div>
              <div className="mx-4 mt-[3px]">
                <BoostVideo />
              </div>
              <BureauLogo />
              <div className="grid place-items-center w-full">
                <CheckMarkTexts textClassName="my-[3px]" />
              </div>
            </>
          )}
          <div className="flex flex-row w-full lg:min-h-[601px] ml-1">
            <div className="lg:self-center flex grow justify-center md:mt-12 lg:mt-0 lg:justify-start">
              <LandingForm />
            </div>
            {!belowMd && (
              <div className="pt-20 lg:mt-0 w-full md:w-1/3 lg:w-1/2">
                <BoostVideo />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="bg-neutral-50 text-black">
        <div
          className="mx-auto px-6"
          style={{ maxWidth: belowMd ? 564 : 1151 }}
        >
          <ActionCard
            title="No credit history required"
            buttonText="Check Your Score Today"
            src={ImageNoCreditHistory}
            belowMd={belowMd}
            isImageLeft={false}
          >
            <div style={{ letterSpacing: 0.1 }}>
              You are worth more than just a number (a.k.a. an arbitrary credit
              score). We conduct individualized assessments based on financial
              history and other sources and use our proprietary algorithm to
              determine your credit worthiness.
            </div>
          </ActionCard>
          <ActionCard
            title="Customizable Spending Power"
            buttonText="Take Control of Your Credit"
            src={ImageCustomizableSpendingPower}
            belowMd={belowMd}
          >
            <>
              <div className="break-words" style={{ letterSpacing: 0.1 }}>
                Since we do not rely on a credit score to determine your
                spending power, we have the flexibility to update your spending
                power in real time! Spending power ranges from $100 - $30,000.*
              </div>
              <div
                className="break-words text-xs"
                style={{ letterSpacing: 0.1 }}
              >
                * Not all applicants will be approved for the maximum spending
                power.
              </div>
            </>
          </ActionCard>
          <ActionCard
            title="Build Your Credit Score"
            buttonText="Build Your Credit Now"
            src={ImageBuildYourCreditScore}
            belowMd={belowMd}
            isImageLeft={false}
          >
            <div style={{ letterSpacing: 0.1 }}>
              Through consistent on-time payments, your credit score will grow.
              Set up an &quot;optional&quot; 7 day pay to maximize this cycle
              and increase the rate in which your credit score can improve.
            </div>
          </ActionCard>
        </div>
      </div>
      <div className="bg-neutral-300 flex flex-col w-full">
        <TestimonialCards className="mt-6 flex flex-col justify-center items-center mx-auto" />
        <SocialProofImages />
      </div>
      <PageBreak belowMd={belowMd} />
      <div className="mt-4 bg-black">
        <BoostFooter isBelow={isBelow} />
        <img src={boostWave} alt="" className="w-full xl:w-1/2" />
      </div>
    </div>
  );
};

export default KosmofiLanding;
